module.exports = __webpack_public_path__ + "media/country_flags/no-83e5f9bb.png";